import { render, staticRenderFns } from "./CongrateFinishParcours.vue?vue&type=template&id=be5526e2&scoped=true&"
import script from "./CongrateFinishParcours.vue?vue&type=script&lang=js&"
export * from "./CongrateFinishParcours.vue?vue&type=script&lang=js&"
import style0 from "./CongrateFinishParcours.vue?vue&type=style&index=0&id=be5526e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5526e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
